import React, { useEffect, useMemo, useState, useContext } from "react";
import "./style.scss";
import { useParams, useSearchParams } from "react-router-dom";
import DeviceHeader from "../../components/device/device_header/DeviceHeader";
import "./style.scss";
import DeviceDashboard from "../../components/device/device_dashboard/DeviceDashboard";
import DevicePlanning from "../../components/device/device_planning/DevicePlanning";
import InstallationTestComponent from "../../components/device/installation_test/InstallationTest";
import ThermalBatteryView from "../../components/device/thermal_battery/ThermalBatteryView";
import { DispatchProps, StateProps } from "../../store";
import { mapDispatchToProps, mapStateToProps } from "../../store/dispatcher";
import { connect } from "react-redux";
import { Device as DeviceType, isDeviceDetailLoaded } from "../../lib/Device";
import { Home as HomeType, isHomeDetailLoaded } from "../../lib/Home";
import DeviceNotFound from "../../components/device/device_not_found/DeviceNotFound";
import AuthContext from "../../contexts/AuthContext";

const Device = ({
  devices,
  homes,
  updateDevice,
  fetchDevice,
  fetchHome,
}: {
  devices: DeviceType[];
  homes: HomeType[];
  updateDevice: any;
  fetchDevice: (id: number) => void;
  fetchHome: (id: number) => void;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { home_id, device_id } = useParams();
  const { user } = useContext(AuthContext);
  const current_view = searchParams.get("current-view");
  
  const allowedViews = useMemo(() => 
    user.is_installer 
      ? ["dashboard", "plan", "installation-test", "thermal-battery"]
      : ["dashboard", "plan"],
    [user.is_installer]
  );
  
  const [currentView, setCurrentView] = useState(
    current_view && allowedViews.includes(current_view) 
      ? current_view 
      : "dashboard"
  );
  const [controle, setControle] = useState("NORMAL");

  const current_device = useMemo(
    () =>
      devices?.filter(
        (device) =>
          device.id === parseInt(device_id ? device_id : "0") &&
          device.home === parseInt(home_id ? home_id : "0")
      ),
    [device_id, devices, home_id]
  );

  const update_controle = (ctrl: string) => {
    setControle(ctrl);
    if (current_device.length) {
      updateDevice({ id: current_device[0].id, data: { running_state: ctrl } });
    }
  };

  const update_current_view = (new_view: string) => {
    setCurrentView(new_view);
    setSearchParams({ "current-view": new_view });
  };

  useEffect(() => {
    const id = parseInt(device_id ? device_id : "0");
    if (!id) return;
    const device = devices?.find((entry) => entry.id === id);
    if (!isDeviceDetailLoaded(device)) {
      fetchDevice(id);
    }
  }, [device_id, devices, fetchDevice]);

  useEffect(() => {
    const homeId = parseInt(home_id ? home_id : "0");
    if (!homeId) return;
    const home = homes?.find((entry) => entry.id === homeId);
    if (!isHomeDetailLoaded(home)) {
      fetchHome(homeId);
    }
  }, [home_id, homes, fetchHome]);

  useEffect(() => {
    if (current_device?.length) {
      setControle(current_device[0].running_state);
    }
  }, [current_device]);

  useEffect(() => {
    const viewFromUrl = searchParams.get("current-view");
    if (viewFromUrl && allowedViews.includes(viewFromUrl)) {
      if (viewFromUrl !== currentView) {
        setCurrentView(viewFromUrl);
      }
    } else if (
      (viewFromUrl === "installation-test" || viewFromUrl === "thermal-battery") &&
      !user.is_installer
    ) {
      setSearchParams({ "current-view": "dashboard" });
      setCurrentView("dashboard");
    }
  }, [searchParams, user.is_installer, allowedViews, currentView, setSearchParams]);

  if (current_device && current_device.length === 0) {
    return (
      <div className="device-view">
        <DeviceNotFound />
      </div>
    );
  }

  return (
    <div className="device-view">
      <DeviceHeader
        currentView={currentView}
        setCurrentView={update_current_view}
        controle={controle}
        setControle={update_controle}
      />
      <div className="device-content">
        {currentView === "dashboard" && <DeviceDashboard />}
        {currentView === "plan" && <DevicePlanning />}
        {currentView === "installation-test" && user.is_installer && <InstallationTestComponent />}
        {currentView === "thermal-battery" && user.is_installer && <ThermalBatteryView />}
      </div>
    </div>
  );
};

export default connect<StateProps, DispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(Device);
